import { ApiOrgType } from 'api/org/types/ApiOrgType';
import { trackPageView } from 'utils/analytics/track/trackPageView';

type Args = {
  name: string;
  id: string;
  orgType: ApiOrgType;
};

export function trackViewOrgPageView({ name, id, orgType }: Args) {
  trackPageView('Org Listing Page', {
    name,
    id,
    org_type: orgType,
    page_type: 'Org Listings',
  });
}
